// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader_14nszRX","wrapper":"loader_wrapper_3-wfG-f"};